import React from "react";
import Sidebar from "../../components/Sidebar";
import GroupPanel from "./components/GroupPanel";
import CountryTable from "./components/CountryTable";
import { useGroupStatus } from "./hooks/useCountrySettings";

// Two independent group switches for app review plus every country's own
// switches. Existing users keep their accounts whatever is switched here;
// the mobile app reads the crypto setting on its next launch or refresh.
const CountrySettings = () => {
  const { data: status } = useGroupStatus();

  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      <Sidebar />

      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Country Settings</h1>

        <div className="flex flex-wrap gap-4 mb-6">
          <GroupPanel
            group="registration"
            title="Registration (app submission)"
            description="Who may create an account. Disabling switches registration off for the countries we are not licensed in, including everything Quidax prohibits. Enabling brings back the excluded countries Quidax does not prohibit. Any single country, including a Quidax-prohibited one, can be allowed with its own switch below."
            restrictLabel="Disable unlicensed countries"
            restoreLabel="Enable allowed countries"
            status={status?.registration}
          />
          <GroupPanel
            group="crypto"
            title="Crypto"
            description="Where the mobile app shows crypto. Enabling turns crypto on for every country except Quidax-prohibited, sanctioned and crypto-banned ones, which stay locked off. Disabling turns it off everywhere except Nigeria (the app review setting). Switch single countries off with their own switch. This does not change who can register."
            restrictLabel="Disable unlicensed countries"
            restoreLabel="Enable allowed countries"
            status={status?.crypto}
          />
        </div>

        <p className="mb-4 text-xs text-gray-500">
          Registration can be allowed for any country. Crypto is locked off (padlock) for Quidax-prohibited, sanctioned and
          crypto-banned countries. A warning mark means Quidax prohibits onboarding from that country. Every change is recorded
          with your email.
        </p>

        <CountryTable />
      </div>
    </div>
  );
};

export default CountrySettings;
